import { CommonModule,formatDate } from '@angular/common';
import { ChangeDetectionStrategy,Component,EventEmitter,Input,OnInit,Output } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Actions,ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BehaviorSubject, combineLatest, defer, firstValueFrom, from, Observable, of } from 'rxjs';
import { distinctUntilChanged,filter,map,shareReplay,switchMap,take,takeUntil,tap,withLatestFrom } from 'rxjs/operators';
import { EventTypeEntity } from '../../../../dave-data-module/entities/event-type.entity';
import { EventEntity,EventStateEnum,EventStateEnumColorMap } from '../../../../dave-data-module/entities/event.entity';
import { GeneratedDocumentsEntity } from '../../../../dave-data-module/entities/generatedDocuments.entity';
import { FrontendDate } from '../../../../dave-data-module/helper/backend-frontend-conversion.helper';
import { getFetched$ } from '../../../../dave-data-module/helper/helper';
import {
CategoriesWithAssignments,
EventCategoriesDataService
} from '../../../../dave-data-module/services/event-categories.service-data-service';
import { State } from '../../../../dave-data-module/State';
import { ConstructionDiaryActionTypes } from '../../../../dave-data-module/State/actions/construction-diary.actions';
import { EventCategoriesActionTypes } from '../../../../dave-data-module/State/actions/event-categories.actions';
import { EventsActionTypes } from '../../../../dave-data-module/State/actions/events.actions';
import {
    getCommissionById, getCommissionsActive,
    getCommissionsFetched,
} from '../../../../dave-data-module/State/selectors/commission.selector';
//import { getConstructionDiaries,getConstructionDiariesFetched } from '../../../../dave-data-module/State/selectors/construction-diary.selectors';
import {
selectEventCategories,selectEventCategoriesFetched
} from '../../../../dave-data-module/State/selectors/event-Categories.selector';
import { getEventTypeById } from '../../../../dave-data-module/State/selectors/event-type.selector';
import { getEventById,getEventsSortedByCreatedAt } from '../../../../dave-data-module/State/selectors/events.selectors';
import { getFiles } from '../../../../dave-data-module/State/selectors/files.selectors';
import { getGeneratedDocuments } from '../../../../dave-data-module/State/selectors/generatedDocuments.selectors';
import { DocumentEditorDialogComponent,DocumentEditorDialogComponentCloseData,DocumentEditorDialogComponentDialogData } from '../../../../dave-document-editor-module/components/document-editor-dialog/document-editor-dialog.component';
import { DaveDoubleIconModule } from '../../../../dave-double-icon/dave-double-icon.module';
import { ListCardDialogComponent,ListCardDialogComponentDialogData } from '../../../../dave-list-card/components/list-card-dialog/list-card-dialog.component';
import { DaveListCardcolumnProperties } from '../../../../dave-list-card/dave-list-card.component';
import { DaveListCardModule } from '../../../../dave-list-card/dave-list-card.module';
import { AppButtonModule } from '../../../../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../../../../dave-utils-module/app-filter-module/app-filter.module';
import { IconPipeModule } from '../../../../dave-utils-module/icon-pipe/icon-pipe.module';
import { isNotNullOrUndefined,sameDay } from '../../../../helper/helper';
import { GeneratedDocumentsPageMeta } from '../../../../helper/page-metadata';
import { DiaryDataService } from '../../../../services/diary-data.service';
import { LoadingService } from '../../../../services/loading.service';
import { AddEventDialogComponent,AppAddEventDialogData,AppAddEventDialogDataReturn } from '../add-event-dialog/add-event-dialog.component';
import { InterruptionEventService } from './interruption-event.service';
import {
    FILTER_TYPE_SEARCH_MULTI_SELECT, FILTER_TYPE_SELECT, FILTER_TYPE_TIMESPAN,
    FilterOption,
    IFilterTypeSearchMultiSelectValue,
} from '../../../../dave-utils-module/app-filter-module/app-filter/app-filter.component';
import {
    getBVCustomNameFetched,
    getBVCustomNamesActive,
} from '../../../../dave-data-module/State/selectors/b-v-custom-name.selector';
import { getCustomers, getCustomersFetched } from '../../../../dave-data-module/State/selectors/customers.selectors';
import {
    getChartOfAccounts,
    getChartOfAccountsFetched,
} from '../../../../dave-data-module/State/selectors/chartOfAccount.selectors';
import { FilterTypes } from '../../../../services/default-filter.service';
import {
    BusinessVolumeCostStateEnum,
    BusinessVolumeStatusEnumNameMap,
} from '../../../../dave-data-module/entities/business-volume.entity';
import { MatBadgeModule } from '@angular/material/badge';
import { Moment } from 'moment/moment';
import { getARLTemplateTypesFetched } from '../../../../dave-data-module/State/selectors/accounting.selector';
import {
    ExportEventDialogComponent,
    ExportEventDialogComponentDialogData, ExportEventDialogComponentDialogReturnData,
} from '../export-event-dialog/export-event-dialog.component';
import { EventDataService } from 'src/app/dave-data-module/services/event.service-data-service';
import { ConstructionDiaryEntity } from '../../../../dave-data-module/entities/construction-diary.entity';
import {
    getConstructionDiariesByCommissionId,
    getConstructionDiariesFetchedByCommissionId, getConstructionDiaryFetchedByCommissionId,
} from '../../../../dave-data-module/State/selectors/construction-diary.selectors';
import {
    ConstructionDiaryByCommissionIdResolverWithoutRoute
} from '../../../../dave-data-module/guards/construction-diary.resolver';
interface EventFilterValues {
    category?: IFilterTypeSearchMultiSelectValue[];
}
@Component({
    selector: 'app-interruption-events-list-card[CommissionId][EventTypeId]',
    standalone: true,
    imports: [CommonModule, DaveListCardModule, AppButtonModule, MatTooltipModule, DaveDoubleIconModule, IconPipeModule, AppFilterModule, FontAwesomeModule, MatBadgeModule],
    templateUrl: './interruption-events-list-card.component.html',
    styleUrls: ['./interruption-events-list-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InterruptionEventsListCardComponent {
    @Output() Count = new EventEmitter<number>();

    @Input() Expanded = true;
    @Input() IsExpandable = false;
    @Input() Headline = '';

    private eventTypeId$ = new BehaviorSubject<number>(null);
    @Input() set EventTypeId(v: number) {
        if (v !== this.eventTypeId$.value) {
            this.eventTypeId$.next(v);
        }
    }
    private commissionId$ = new BehaviorSubject<number>(null);
    @Input() set CommissionId(v: number) {
        if (v !== this.commissionId$.value) {
            this.commissionId$.next(v);
        }
    }

    @Input() canCreate = false;


    private resCategories$: Observable<CategoriesWithAssignments>
    private resCategories: CategoriesWithAssignments;
    protected eventType$: Observable<EventTypeEntity>;
    protected data$: Observable<MatTableDataSource<DaveListCardcolumnProperties<EventEntity>>>;
    // protected hasSuffixButton$: Observable<boolean>;
    protected hasSuffixButton: boolean;
    constructor(
        private store: Store<State>,
        private actions$: Actions,
        private dialog: MatDialog,
        ls: LoadingService,
        diaryService: DiaryDataService,
       // private constructionDiaryResolver: ConstructionDiaryResolver,
        private interruptionEventService: InterruptionEventService,
        private eventCategoriesDataService: EventCategoriesDataService,
        private eventDataService: EventDataService,
    ) {

        this.store.select(selectEventCategoriesFetched).pipe(
            take(1)
        ).subscribe((fetched) => {
            if (!fetched) {
                this.store.dispatch(EventCategoriesActionTypes.Load({ Payload: {} }));
            }
        });

        this.resCategories$ = this.store.select(selectEventCategoriesFetched).pipe(
            switchMap(fetched =>
                fetched ? this.store.select(selectEventCategories) : from(this.eventCategoriesDataService.getRequest())
            ),
            shareReplay({ refCount: true, bufferSize: 1 }),
        );

        this.eventType$ = this.eventTypeId$.pipe(switchMap((eventTypeId: number) => (eventTypeId ? store.select(getEventTypeById({ id: eventTypeId })).pipe(tap(et => {
            if (!et) {
                throw 'app-interruption-events-list-card: event type not found, ID:'+eventTypeId
            }
        })) : of(null))));
        this.data$ = of(new MatTableDataSource<DaveListCardcolumnProperties<EventEntity>>([])).pipe(
            switchMap((tableDataSource) =>
                combineLatest([
                    this.eventType$,
                    // store.select(getEventsSortedByCreatedAt),
                    this.commissionId$.pipe(
                        filter(isNotNullOrUndefined),
                        switchMap(id => this.eventDataService.GetFromCommission$(id)),
                        map(events => events.sort((a, b) => (a.CreatedAt < b.CreatedAt ? 1 : -1)))
                    ),
                    this.commissionId$, store.select(getGeneratedDocuments),
                    this.store.select(selectEventCategories),
                    this.resCategories$
                ]).pipe(
                    filter((v) => v.every(isNotNullOrUndefined)),
                    map(([eventType, events, commissionId, genDocs, categories]) => {
                       // this.resCategories = categories
                        let data = events
                            .filter((e) => e.EventTypeId === eventType.Id && e.CommissionId === commissionId)
                            .map<DaveListCardcolumnProperties<EventEntity>>((e) => {
                                const docs = genDocs.filter((gd) => gd.AdditionalData?.ConstructionDiary?.EventIds?.includes(e.Id));
                                return {
                                    ...e,
                                    EventNumber: e.EventNumber ?? e.Id.toString(),
                                    Name: e.Name,
                                    cssClass: e.State ? 'event-list-entry-custom-state-style ' + (EventStateEnumColorMap.get(e.State) || '') : '',
                                    suffixButton: docs.length
                                        ? {
                                              icon: GeneratedDocumentsPageMeta.Icon,
                                              tooltip: 'Bericht anzeigen',
                                              onClick: (v) => {
                                                  if (docs.length === 1) {
                                                      dialog.open<DocumentEditorDialogComponent, DocumentEditorDialogComponentDialogData, DocumentEditorDialogComponentCloseData>(DocumentEditorDialogComponent, {
                                                          ...DocumentEditorDialogComponent.DefaultConfig,
                                                          data: {
                                                              generatedDocumentId: docs[0].Id,
                                                          },
                                                      });
                                                  } else {
                                                      const dialogRef = dialog.open<ListCardDialogComponent<GeneratedDocumentsEntity>, ListCardDialogComponentDialogData<GeneratedDocumentsEntity>>(ListCardDialogComponent, {
                                                          ...ListCardDialogComponent.DefaultConfig,
                                                          data: {
                                                              Headline: 'Export auswählen',
                                                              EmptyText: 'Keine Exporte vorhanden',
                                                              Data: docs,
                                                              DisplayedCollums: ['DisplayName'],
                                                              Clickable: true,
                                                              HasSuffixButton: false,
                                                          },
                                                      });
                                                      dialogRef.componentInstance.EntryClicked$.pipe(takeUntil(dialogRef.afterClosed())).subscribe((gd) => {
                                                          dialogRef.close();
                                                          dialog.open<DocumentEditorDialogComponent, DocumentEditorDialogComponentDialogData, DocumentEditorDialogComponentCloseData>(DocumentEditorDialogComponent, {
                                                              ...DocumentEditorDialogComponent.DefaultConfig,
                                                              data: {
                                                                  generatedDocumentId: gd.entry.Id,
                                                              },
                                                          });
                                                      });
                                                  }
                                              },
                                          }
                                        : eventType.GeneratedDocumentsTypeSlugsForDiary
                                        ? {
                                              icon: GeneratedDocumentsPageMeta.Icon,
                                              icon2: 'plus',
                                              tooltip: 'Bericht hinzufügen',
                                              onClick: (e) => {
                                                  dialog.open<ExportEventDialogComponent, ExportEventDialogComponentDialogData, ExportEventDialogComponentDialogReturnData>(ExportEventDialogComponent, {
                                                      ...ExportEventDialogComponent.DefaultConfig,
                                                      data: {
                                                          EventIds: [e.Id],
                                                          GeneratedDocumentsType: eventType.GeneratedDocumentsTypeSlugsForDiary,
                                                      }
                                                  }).afterClosed().subscribe((res) => {
                                                      if (res?.length === 1) {
                                                          dialog.open<DocumentEditorDialogComponent, DocumentEditorDialogComponentDialogData, DocumentEditorDialogComponentCloseData>(DocumentEditorDialogComponent, {
                                                              ...DocumentEditorDialogComponent.DefaultConfig,
                                                              data: {
                                                                  generatedDocumentId: res[0].id,
                                                              },
                                                          });
                                                      }
                                                  });
                                              },
                                          }
                                        : undefined,
                                };
                            });
                        this.hasSuffixButton = data.some((c) => c.suffixButton);

                        return data ;

                    }),
                    switchMap((data) =>
                        combineLatest([this.EventFilterValues$, this.resCategories$]).pipe(
                            map(([filterValues, resCategories]) => {

                                const categoryIds: number[] = filterValues.category.map(c => Number(c.id));
                                const e2ec = resCategories.Event2EventCategories
                                    .filter(event => categoryIds.includes(event.CategoryId))
                                    .map(e => e.EventId);
                                return data.filter((d) => filterValues.category.length === 0 || e2ec.includes(d.Id));
                            })
                        )
                    ),
                    distinctUntilChanged((a, b) => a.length === b.length && a.every((v, i) => v === b[i])),
                    tap((events) => {
                        tableDataSource = new MatTableDataSource([...events]);
                    }),
                    map(() => tableDataSource),
                    distinctUntilChanged(),
                    shareReplay({ bufferSize: 1, refCount: true }),
                ),
            ),
        );
        // this.hasSuffixButton$ = this.data$.pipe(map((d) => d.data.some((e) => e.suffixButton)));
    }
    private async getCommission() {
        return await firstValueFrom(
            this.commissionId$.pipe(
                filter(isNotNullOrUndefined),
                switchMap((id) => this.store.select(getCommissionById({ id }))),
            ),
        );
    }

    public async OpenAddEventDialog() {
        const commission = await this.getCommission();
        const diaries = await firstValueFrom(
            getFetched$(
                this.store,
                getConstructionDiaryFetchedByCommissionId(commission.Id),
                getConstructionDiariesByCommissionId(commission.Id),
                { resolve: () => ConstructionDiaryByCommissionIdResolverWithoutRoute(this.store, commission.Id).subscribe() },
            ),
        );
        const eventType = await firstValueFrom(this.eventType$.pipe(filter(isNotNullOrUndefined)));
        // const date = new Date();
        const diary = diaries.find((d) => sameDay(d.Date, new Date()));
        // this.store.dispatch(
        //     EventsActionTypes.AddEvent({
        //         Payload: {
        //             isTask: false,
        //             eventTypeId: eventType.Id,
        //             commissionId: commission.Id,
        //             customerId: commission.CustomerId,
        //             eventDate: FrontendDate(date),
        //             state: EventStateEnum.New,
        //             name: eventType.Name + ' ' + formatDate(date, 'dd.MM.yyyy', 'de-DE'),
        //         },
        //     }),
        // );


            this.resCategories = await firstValueFrom(this.store.select(selectEventCategories));
            this.dialog
                .open<AddEventDialogComponent, AppAddEventDialogData, AppAddEventDialogDataReturn>(AddEventDialogComponent, {
                    data: {
                        eventTypeId: eventType.Id,
                        headline: eventType.Name,
                        hideDate: false,
                        categories: this.resCategories,
                        diary: diary,
                        commissionId: commission.Id,
                        newEvent: true,
                    },
                    ...AddEventDialogComponent.DefaultConfig,
                })
                .afterClosed()

    }
    public EventFilterValues$: BehaviorSubject<EventFilterValues> = new BehaviorSubject({
        category: [],
    });
    public FilterAmount$ = this.EventFilterValues$.pipe(
        map((filter) => {
            let amount = 0;
            if (filter.category?.length) {
                amount += 1;
            }
            return amount;
        }),
    );

    public EventFilterSettings: Observable<FilterOption<keyof EventFilterValues>[]> =
        combineLatest([
            this.store.select(selectEventCategories).pipe(filter((categories): categories is CategoriesWithAssignments => !!categories),),
        ]).pipe(
        map(([categories]) => {
            const filters = [];



                filters.push({
                    Name: 'category',
                    Type: FILTER_TYPE_SEARCH_MULTI_SELECT,
                    Label: 'Kategorie',
                    Values: categories.EventCategories.map<IFilterTypeSearchMultiSelectValue<string>>((category) => ({
                        id: category.Id.toString(),
                        label: category.Name,
                    })),
                });

            return filters;
        })
    );


    public async OpenEditEventDialog(event: Partial<EventEntity>, element?: HTMLElement) {
        this.resCategories = await firstValueFrom(this.store.select(selectEventCategories));
        await this.interruptionEventService.OpenEditEventDialog(event, this.commissionId$.value, element, this.resCategories);
        this.resCategories = await firstValueFrom(this.store.select(selectEventCategories));
    }
}
